import OnboardingLogin from './OnboardingLogin';
import OnboardingReviu from './OnboardingReviu';
import OnboardingEnviu from './OnboardingEnViu';
import OnboardingEnviuPoC from './OnboardingEnViuPoC';
import OnboardingBase from './OnboardingBase';
import { useUser } from 'hooks/useUser/useUser';
import { useRouter } from 'next/router';
import { useEffect, useRef, useState } from 'react';

const parseDate = (dateString) => {
    if (!dateString) return null;

    const parsedDate = new Date(dateString.replace(' ', 'T'));
    return Number.isNaN(parsedDate.getTime()) ? null : parsedDate;
};

export default function Component(props) {
    const router = useRouter();
    const { isAuthenticated, loginState, loginStateTypes } = useUser();
    const { items } = props;
    const [onboardingActiu, setOnboardingActiu] = useState(null);
    const onboardingSeleccionat = useRef(false);

    const isLoginStateResolved = loginState === loginStateTypes.AUTHENTICATED || loginState === loginStateTypes.GUEST;
    const isAuthenticationResolved = isLoginStateResolved && isAuthenticated !== null;

    useEffect(() => {
        if (router.query.no_onb !== undefined || !items || !isAuthenticationResolved || onboardingSeleccionat.current) return;

        const esOnboardingActiu = (item) => {
            if (!item.actiu) return false;

            const dataActual = new Date();

            const dataInici = parseDate(item.dataPublicacio);
            const dataFi = parseDate(item.dataDespublicacio);

            const estaActiu = (!dataInici || dataActual >= dataInici) && (!dataFi || dataActual <= dataFi);

            return estaActiu && (isAuthenticated ? item.usuarisLogats === true : item.usuarisNoLogats === true);
        };

        onboardingSeleccionat.current = true;
        setOnboardingActiu(items.find(esOnboardingActiu) || null);
    }, [items, isAuthenticationResolved, isAuthenticated, router.query.no_onb]);

    // ✅ Si existeix el paràmetre no_onb a la URL, no mostrar cap modal onboarding
    if (router.query.no_onb !== undefined) return null;
    if (!items) return null;
    if (!isAuthenticationResolved || !onboardingSeleccionat.current) return null;

    if (onboardingActiu) {
        switch (onboardingActiu.tipus) {
            case 'OnboardingEnviu':
                return <OnboardingEnviu {...props} />;
            case 'OnboardingEnviuPoC':
                return <OnboardingEnviuPoC {...props} />;
            case 'OnboardingReviu':
                return <OnboardingReviu {...props} />;
            case 'OnboardingLogin':
                return <OnboardingLogin {...props} />;
            case 'custom':
                return <OnboardingBase onboardingActiu={onboardingActiu} />;
        }
    }
    return null;
}
